import { Component, OnInit } from '@angular/core';
import { AdumoEftComponent } from './methods/adumo-eft/adumo-eft.component';
import { ApplePayComponent } from './methods/apple-pay/apple-pay.component';
import { DebitCreditCardComponent } from './methods/debit-credit-card/debit-credit-card.component';
import { GooglePayComponent } from './methods/google-pay/google-pay.component';
import { MasterpassComponent } from './methods/masterpass/masterpass.component';
import { MobicredComponent } from './methods/mobicred/mobicred.component';
import { OttVoucherComponent } from './methods/ott-voucher/ott-voucher.component';
import { OzowComponent } from './methods/ozow/ozow.component';
import { ZapperComponent } from './methods/zapper/zapper.component';
import { PayJustNowComponent } from './methods/pay-just-now/pay-just-now.component';
import { LifestyleRewardsComponent } from './methods/lifestyle-rewards/lifestyle-rewards.component';
import { SessionService } from '../../../../services/session/session.service';
import { Session } from '../../../../interfaces/session-data';
import { Router } from '@angular/router';

import { ApplePayComponent as ApplePayPromoComponent } from './promotions/apple-pay/apple-pay.component';
import { DebitCreditCardComponent as DebitCreditCardPromoComponent } from './promotions/debit-credit-card/debit-credit-card.component';
import { GooglePayComponent as GooglePayPromoComponent } from './promotions/google-pay/google-pay.component';
import { MasterpassComponent as MasterPassPromoComponent } from './promotions/masterpass/masterpass.component';
import { MobicredComponent as MobicredPromoComponent } from './promotions/mobicred/mobicred.component';
import { OttVoucherComponent as OttVoucherPromoComponent } from './promotions/ott-voucher/ott-voucher.component';
import { OzowComponent as OzowPromoComponent } from './promotions/ozow/ozow.component';
import { VisaClickToPayComponent as VisaClickToPayPromoComponent } from './promotions/visa-click-to-pay/visa-click-to-pay.component';
import { ZapperComponent as ZapperPromoComponent } from './promotions/zapper/zapper.component';
import { PayJustNowComponent as PayJustNowPromoComponent} from './promotions/pay-just-now/pay-just-now.component';
import { LifestyleRewardsComponent as LifestyleRewardsPromoComponent } from './promotions/lifestyle-rewards/lifestyle-rewards.component';
import { GooglePayService } from '../../../../services/google-pay.service';
import { CardSchema } from '../../../../interfaces/card/CardSchema';

@Component({
  selector: 'app-payments-version-two',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
})
export class PaymentsComponent implements OnInit {
  private session: Session;
  private urlList: string[];

  public showList: boolean;
  public paymentMethod: any[];
  public priorityMethod: any[];
  public promotionalContainer: any;
  public selectedPaymentMethod: string;

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private googlePayService: GooglePayService
  ) {
    this.sessionService.getEmitPaymentMethodPromotion().subscribe((method) => {
      this.showPromotion(method);
    });
  }

  ngOnInit(): void {
    this.paymentMethod = [];
    let shownMethods = [];
    this.urlList = [];
    this.session = JSON.parse(sessionStorage.getItem('sessionData'));
    this.showList = true;
    const paymentMethodContent = {
      card: {
        key: 'debit-credit-card',
        url: `${this.sessionService.getVirtualTwoBaseurl()}/card/add`,
      },
      googlePay: {
        key: 'google-pay',
        url: `${this.sessionService.getVirtualTwoBaseurl()}/card/google-pay`,
      },
      applePay: {
        key: 'apple-pay',
        url: `${this.sessionService.getVirtualTwoBaseurl()}/card/apple-pay`,
      },
      zapper: {
        key: 'zapper',
        url: `${this.sessionService.getVirtualTwoBaseurl()}/zapper`,
      },
      ozow: {
        key: 'ozow',
        url: `${this.sessionService.getVirtualTwoBaseurl()}/ozow`,
      },
      mobicred: {
        key: 'mobicred',
        url: `${this.sessionService.getVirtualTwoBaseurl()}/mobicred/login`,
      },
      masterpass: {
        key: 'masterpass',
        url: `${this.sessionService.getVirtualTwoBaseurl()}/master_pass`,
      },
      ottVoucher: {
        key: 'ott-voucher',
        url: `${this.sessionService.getVirtualTwoBaseurl()}/ott_voucher/input`,
      },
      lifestyleRewards: {
        key: 'lifestyle-rewards',
        url: `${this.sessionService.getVirtualTwoBaseurl()}/lifestyle_rewards/login`,
      },
      payJustNow: {
        key: 'pay-just-now',
        url: `${this.sessionService.getVirtualTwoBaseurl()}/pay-just-now`,
      },
    };

    const sessionDisplayHasNoMcpAmounts =
      this.session.sessionDisplayInformation.mcpAmounts == null ||
      this.session.sessionDisplayInformation.mcpAmounts.length != 1;

    this.session.virtualConfiguration.paymentTypes.forEach((x) => {
      switch (x.code) {
        case 'CARD':
          let supportedCardSchema:CardSchema[] = [];
          this.session.virtualConfiguration.supportedCardSchemas.forEach((y) => {
            switch(y.code){
              case "americanExpress":
                supportedCardSchema.push({
                  code:y.code,
                  cardName: y.cardName,
                  imageName: 'assets/icons/Icons/card-types/amex.svg'
                });
                break;
              case "mastercard":
                supportedCardSchema.splice(0,0,{
                  code:y.code,
                  cardName: y.cardName,
                  imageName: 'assets/icons/Icons/card-types/mastercard.svg'
                });
                break;
              case "visa":
                supportedCardSchema.splice(0,0,{
                  code:y.code,
                  cardName: y.cardName,
                  imageName: 'assets/icons/Icons/card-types/visa.svg'
                });
                break;
              case "dinersClub":
                supportedCardSchema.push({
                  code:y.code,
                  cardName: y.cardName,
                  imageName: 'assets/icons/Icons/card-types/diners.svg'
                });
                break;
              case "maestro":
                supportedCardSchema.push({
                  code:y.code,
                  cardName: y.cardName,
                  imageName: 'assets/icons/Icons/card-types/maestro.svg'
                });
                break;
              default:
                break;
            }
          });
          this.sessionService.setSupportedCardSchema(supportedCardSchema);
          if (
            this.session.sessionDisplayInformation.hideCardMethod?.toLowerCase() !==
            'true'
          ) {
            this.urlList.splice(0, 0, paymentMethodContent.card.url);
            this.paymentMethod.unshift({
              key: paymentMethodContent.card.key,
              component: DebitCreditCardComponent,
            });
            shownMethods.push({
              container: DebitCreditCardPromoComponent,
              visible: true,
              url: paymentMethodContent.card.url,
            });
          } else {
            shownMethods.push({
              container: DebitCreditCardPromoComponent,
              visible: false,
              url: paymentMethodContent.card.url,
            });
          }
          if (
            this.session.sessionDisplayInformation.hideGooglePay?.toLowerCase() !==
            'true'
          ) {
            // Add Google Pay initially
            const googlePayIndex =
              this.session.sessionDisplayInformation.hideCardMethod?.toLowerCase() !==
              'true'
                ? 1
                : 0;
            this.paymentMethod.splice(googlePayIndex, 0, {
              key: paymentMethodContent.googlePay.key,
              component: GooglePayComponent,
            });
            this.urlList.splice(
              googlePayIndex,
              0,
              paymentMethodContent.googlePay.url
            );
            shownMethods.splice(googlePayIndex, 0, {
              container: GooglePayPromoComponent,
              visible: true,
              url: paymentMethodContent.googlePay.url,
            });
            this.showList = this.paymentMethod.length > 1;

            // Check availability and remove if not ready
            this.isReadyToPay().then((isReady) => {
              if (!isReady) {
                console.log('Google Pay check failed, removing from list.');
                const currentGooglePayIndex =
                  this.paymentMethod.indexOf(GooglePayComponent);
                if (currentGooglePayIndex > -1) {
                  this.paymentMethod.splice(currentGooglePayIndex, 1);
                }
                const currentGooglePayUrlIndex = this.urlList.indexOf(
                  paymentMethodContent.googlePay.url
                );
                if (currentGooglePayUrlIndex > -1) {
                  this.urlList.splice(currentGooglePayUrlIndex, 1);
                }
                const shownMethodIndex = shownMethods.findIndex(
                  (m) => m.container === GooglePayPromoComponent
                );
                if (shownMethodIndex > -1) {
                  shownMethods[shownMethodIndex].visible = false;
                }
                this.showList = this.paymentMethod.length > 1;
                // Note: This removal might affect the initially determined promotionalContainer/route if Google Pay was the first visible one.
                // Consider re-evaluating the default route/promo container if necessary based on requirements.
              } else {
                console.log('Google Pay is ready');
                // Potentially re-evaluate default promo/route if needed, though current logic might suffice
                let flag = false;
                for (let x of shownMethods) {
                  if (x.visible) {
                    this.promotionalContainer = x.container;
                    // this.router.navigate([x.url]); // Navigation logic is handled later
                    flag = true;
                    break;
                  }
                }
                if (!flag) {
                  // Find first available method if Google Pay wasn't it or got removed
                  const firstVisible = shownMethods.find((m) => m.visible);
                  if (firstVisible) {
                    this.promotionalContainer = firstVisible.container;
                    // this.router.navigate([firstVisible.url]); // Navigation logic is handled later
                    // Ensure URL is in the list if it wasn't added elsewhere
                    if (!this.urlList.includes(firstVisible.url)) {
                      this.urlList.push(firstVisible.url);
                    }
                  }
                }
              }
            });
          } else {
            // Still add to shownMethods as hidden if configured to be hidden
            shownMethods.push({
              container: GooglePayPromoComponent,
              visible: false,
              url: paymentMethodContent.googlePay.url,
            });
          }
          if (
            this.session.sessionDisplayInformation.hideApplePay?.toLowerCase() !==
            'true'
          ) {
            // Add Apple Pay initially
            const applePayIndex =
              this.session.sessionDisplayInformation.hideCardMethod?.toLowerCase() !==
              'true'
                ? 1
                : 0; // Adjust index based on card visibility
            this.paymentMethod.splice(applePayIndex, 0, {
              key: paymentMethodContent.applePay.key,
              component: ApplePayComponent,
            });
            this.urlList.splice(
              applePayIndex,
              0,
              paymentMethodContent.applePay.url
            );
            shownMethods.splice(applePayIndex, 0, {
              // Use same index logic for shownMethods
              container: ApplePayPromoComponent,
              visible: true,
              url: paymentMethodContent.applePay.url,
            });
            this.showList = this.paymentMethod.length > 1;

            // Check availability and remove if not available
            this.checkApplePayAvailable().then((isAvailable) => {
              if (!isAvailable) {
                console.log('Apple Pay check failed, removing from list.');
                const currentApplePayIndex =
                  this.paymentMethod.indexOf(ApplePayComponent);
                if (currentApplePayIndex > -1) {
                  this.paymentMethod.splice(currentApplePayIndex, 1);
                }
                const currentApplePayUrlIndex = this.urlList.indexOf(
                  paymentMethodContent.applePay.url
                );
                if (currentApplePayUrlIndex > -1) {
                  this.urlList.splice(currentApplePayUrlIndex, 1);
                }
                const shownMethodIndex = shownMethods.findIndex(
                  (m) => m.container === ApplePayPromoComponent
                );
                if (shownMethodIndex > -1) {
                  shownMethods[shownMethodIndex].visible = false;
                }
                this.showList = this.paymentMethod.length > 1;
                // Note: This removal might affect the initially determined promotionalContainer/route if Apple Pay was the first visible one.
                // Consider re-evaluating the default route/promo container if necessary based on requirements.
              } else {
                console.log('Apple Pay is available');
                // Potentially re-evaluate default promo/route if needed
                let flag = false;
                for (let x of shownMethods) {
                  if (x.visible) {
                    this.promotionalContainer = x.container;
                    // this.router.navigate([x.url]); // Navigation logic is handled later
                    flag = true;
                    break;
                  }
                }
                if (!flag) {
                  // Find first available method if Apple Pay wasn't it or got removed
                  const firstVisible = shownMethods.find((m) => m.visible);
                  if (firstVisible) {
                    this.promotionalContainer = firstVisible.container;
                    // this.router.navigate([firstVisible.url]); // Navigation logic is handled later
                    // Ensure URL is in the list if it wasn't added elsewhere
                    if (!this.urlList.includes(firstVisible.url)) {
                      this.urlList.push(firstVisible.url);
                    }
                  }
                }
              }
            });
          } else {
            // Still add to shownMethods as hidden if configured to be hidden
            shownMethods.push({
              container: ApplePayPromoComponent,
              visible: false,
              url: paymentMethodContent.applePay.url,
            });
          }
          break;
        case 'ZAPPER':
          shownMethods.push({
            container: ZapperPromoComponent,
            visible: false,
            url: paymentMethodContent.zapper.url,
          });
          if (
            (this.session.sessionDisplayInformation.hideZapperMethod == null ||
              this.session.sessionDisplayInformation.hideZapperMethod?.toLowerCase() !=
                'true') &&
            sessionDisplayHasNoMcpAmounts
          ) {
            this.urlList.push(paymentMethodContent.zapper.url);
            this.paymentMethod.push({
              key: paymentMethodContent.zapper.key,
              component: ZapperComponent,
            });
            shownMethods[shownMethods.length - 1].visible = true;
          }
          break;
        case 'EFT_OZOW':
          shownMethods.push({
            container: OzowPromoComponent,
            visible: false,
            url: paymentMethodContent.ozow.url,
          });
          if (
            (this.session.sessionDisplayInformation.hideEftOzowMethod == null ||
              this.session.sessionDisplayInformation.hideEftOzowMethod.toLowerCase() !=
                'true') &&
            sessionDisplayHasNoMcpAmounts
          ) {
            this.urlList.push(paymentMethodContent.ozow.url);
            this.paymentMethod.push({
              key: paymentMethodContent.ozow.key,
              component: OzowComponent,
            });
            shownMethods[shownMethods.length - 1].visible = true;
          }
          break;
        case 'MOBICRED':
          shownMethods.push({
            container: MobicredPromoComponent,
            visible: false,
            url: paymentMethodContent.mobicred.url,
          });
          if (
            (this.session.sessionDisplayInformation.hideMobicredMethod ==
              null ||
              this.session.sessionDisplayInformation.hideMobicredMethod?.toLowerCase() !=
                'true') &&
            sessionDisplayHasNoMcpAmounts
          ) {
            this.urlList.push(paymentMethodContent.mobicred.url);
            this.paymentMethod.push({
              key: paymentMethodContent.mobicred.key,
              component: MobicredComponent,
            });
            shownMethods[shownMethods.length - 1].visible = true;
          }
          break;
        case 'MASTER_PASS':
          shownMethods.push({
            container: MasterPassPromoComponent,
            visible: false,
            url: paymentMethodContent.masterpass.url,
          });
          if (
            (this.session.sessionDisplayInformation.hideMasterPassMethod ==
              null ||
              this.session.sessionDisplayInformation.hideMasterPassMethod?.toLowerCase() !=
                'true') &&
            sessionDisplayHasNoMcpAmounts
          ) {
            this.urlList.push(paymentMethodContent.masterpass.url);
            this.paymentMethod.push({
              key: paymentMethodContent.masterpass.key,
              component: MasterpassComponent,
            });
            shownMethods[shownMethods.length - 1].visible = true;
          }
          break;
        case 'OTT_VOUCHER':
          shownMethods.push({
            container: OttVoucherPromoComponent,
            visible: false,
            url: paymentMethodContent.ottVoucher.url,
          });
          if (
            (this.session.sessionDisplayInformation.hideOttVoucherMethod ==
              null ||
              this.session.sessionDisplayInformation.hideOttVoucherMethod?.toLowerCase() !=
                'true') &&
            sessionDisplayHasNoMcpAmounts
          ) {
            this.paymentMethod.push({
              key: paymentMethodContent.ottVoucher.key,
              component: OttVoucherComponent,
            });
            this.urlList.push(paymentMethodContent.ottVoucher.url);
            shownMethods[shownMethods.length - 1].visible = true;
          }
          break;
        case 'PAY_JUST_NOW':
          shownMethods.push({
            container: PayJustNowPromoComponent,
            visible: false,
            url: paymentMethodContent.payJustNow.url,
          });
          if (
            (this.session.sessionDisplayInformation.hidePayJustNowMethod ==
              null ||
              this.session.sessionDisplayInformation.hidePayJustNowMethod?.toLowerCase() !=
                'true') &&
            sessionDisplayHasNoMcpAmounts
          ) {
            this.paymentMethod.push({
              key: paymentMethodContent.payJustNow.key,
              component: PayJustNowComponent,
            });
            this.urlList.push(paymentMethodContent.payJustNow.url);
            shownMethods[shownMethods.length - 1].visible = true;
          }
          break;
        case 'LIFESTYLE_REWARDS':
          shownMethods.push({
            container: LifestyleRewardsPromoComponent,
            visible: false,
            url: paymentMethodContent.lifestyleRewards.url,
          });
          if (
            (this.session.sessionDisplayInformation.hideLifestyleRewardsMethod ==
              null ||
              this.session.sessionDisplayInformation.hideLifestyleRewardsMethod?.toLowerCase() !=
                'true') &&
            sessionDisplayHasNoMcpAmounts
          ) {
            this.paymentMethod.push({
              key: paymentMethodContent.lifestyleRewards.key,
              component: LifestyleRewardsComponent,
            });
            this.urlList.push(paymentMethodContent.lifestyleRewards.url);
            shownMethods[shownMethods.length - 1].visible = true;
          }
          break;
      }
    });

    let flag = false;
    for (let x of shownMethods) {
      if (x.visible) {
        this.promotionalContainer = x.container;
        flag = true;
        break;
      }
    }

    if (!flag) {
      this.promotionalContainer = shownMethods[0].container;
      this.urlList.push(shownMethods[0].url);
    }

    this.showList = this.paymentMethod.length > 1;

    if (this.session.virtualRoute.indexOf('zapper') != -1) {
      this.sessionService.setCurrencyCodeListLock(true);
      this.router.navigate([paymentMethodContent.zapper.url]);
      this.selectedPaymentMethod = paymentMethodContent.zapper.key;
    }
    else if (this.session.virtualRoute.indexOf('card') != -1) {
      this.router.navigate([paymentMethodContent.card.url]);
      this.selectedPaymentMethod = paymentMethodContent.zapper.key;
    }
    else if (this.session.virtualRoute.indexOf('mobicred') != -1) {
      this.sessionService.setCurrencyCodeListLock(true);
      this.router.navigate([paymentMethodContent.mobicred.url]);
      this.selectedPaymentMethod = paymentMethodContent.mobicred.key;
    }
    else if (this.session.virtualRoute.indexOf('ott_voucher') != -1) {
      this.sessionService.setCurrencyCodeListLock(true);
      this.router.navigate([paymentMethodContent.ottVoucher.url]);
      this.selectedPaymentMethod = paymentMethodContent.ottVoucher.key;
    }
    else if (this.session.virtualRoute.indexOf('master_pass') != -1) {
      this.sessionService.setCurrencyCodeListLock(true);
      this.router.navigate([paymentMethodContent.masterpass.url]);
      this.selectedPaymentMethod = paymentMethodContent.masterpass.key;
    }
    else if (this.session.virtualRoute.indexOf('ozow') != -1) {
      this.sessionService.setCurrencyCodeListLock(true);
      this.router.navigate([paymentMethodContent.ozow.url]);
      this.selectedPaymentMethod = paymentMethodContent.ozow.key;
    }
    else if (this.session.virtualRoute.indexOf('pay_just_now')!= -1) {
      this.sessionService.setCurrencyCodeListLock(true);
      this.router.navigate([paymentMethodContent.payJustNow.url]);
      this.selectedPaymentMethod = paymentMethodContent.payJustNow.key;
    }
    else if (this.session.virtualRoute.indexOf('lifestyle_rewards') != -1) {
      this.sessionService.setCurrencyCodeListLock(true);
      this.router.navigate([paymentMethodContent.lifestyleRewards.url]);
      this.selectedPaymentMethod = paymentMethodContent.lifestyleRewards.key;
    } else if (
      this.session.virtualRoute.indexOf('payments') != -1 &&
      this.router.url.indexOf('/transaction-status') == -1
    ) {
      // Remove default navigation to the first payment method
      // this.router.navigate([this.urlList[0]]);

      // Navigate to card method only if it's not hidden
      if (
        this.session.sessionDisplayInformation.hideCardMethod?.toLowerCase() !==
          'true' ||
        this.session.flow?.toLowerCase() === 'card'
      ) {
        this.router.navigate([paymentMethodContent.card.url]);
        this.selectedPaymentMethod = paymentMethodContent.card.key;
      }
      // If there's only one payment method left, navigate to it regardless of the above
      else if (this.paymentMethod.length === 1) {
        this.router.navigate([this.urlList[0]]);
        this.selectedPaymentMethod =
          Object.values(paymentMethodContent).find(
            (x) => x.url === this.urlList[0]
          )?.key || '';
      }
    } else {
      this.sessionService.setCurrencyCodeListLock(true);
      this.router.navigate([
        `${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`,
      ]);
    }

    this.sessionService.emitPaymentMethodList(true);
    this.sessionService.getEmitSelectedPaymentMethod().subscribe((pm) => {
      this.selectedPaymentMethod = pm;
    });
  }

  public toggleListView() {
    this.showList = !this.showList;
  }

  public showPromotion(event: string) {
    console.log(event);
    switch (event) {
      case 'apple-pay':
        this.promotionalContainer = ApplePayPromoComponent;
        break;
      case 'debit-credit-card':
        this.promotionalContainer = DebitCreditCardPromoComponent;
        break;
      case 'google-pay':
        this.promotionalContainer = GooglePayPromoComponent;
        break;
      case 'masterpass':
        this.promotionalContainer = MasterPassPromoComponent;
        break;
      case 'mobicred':
        this.promotionalContainer = MobicredPromoComponent;
        break;
      case 'ott-voucher':
        this.promotionalContainer = OttVoucherPromoComponent;
        break;
      case 'ozow':
        this.promotionalContainer = OzowPromoComponent;
        break;
      case 'zapper':
        this.promotionalContainer = ZapperPromoComponent;
        break;
      case 'visa-click-to-pay':
        this.promotionalContainer = VisaClickToPayPromoComponent;
        break;
      case 'pay-just-now':
        this.promotionalContainer = PayJustNowPromoComponent;
        break;
      case 'lifestyle-rewards':
        this.promotionalContainer = LifestyleRewardsPromoComponent;
        break;
    }
    this.toggleListView();
  }

  async isReadyToPay(): Promise<boolean> {
    return await this.googlePayService.isGooglePayAvailable();
  }

  async checkApplePayAvailable(): Promise<boolean> {
    if (!(window as any).ApplePaySession) {
      console.log('ApplePay is not supported in this browser.');
      return false;
    }
    return true;
  }
  private isInIframe(): boolean {
    try {
      console.log('isInIframe:', window.self !== window.top);
      return window.self !== window.top;
    } catch (e) {
      console.log('isInIframe exception defaulting to true ', e);
      return true;
    }
  }
}
